import { ImageryLayer, SingleTileImageryProvider, ClassificationType } from 'cesium';
import {getResource} from '../_util/getToken';

const getUrlAndRectangle = (options) => {
    const {map, token, params} = options;
    let rectangle = map.camera.computeViewRectangle();

    //地理坐标（弧度）转经纬度坐标
    let extent = [rectangle.west / Math.PI * 180, rectangle.south / Math.PI * 180, rectangle.east / Math.PI * 180, rectangle.north / Math.PI * 180];

    let _params = {
        service: 'WMS',
        version: '1.1.1',
        request: 'GetMap',
        format: 'image/png',
        transparent: 'true',
        styles: '',
        layers: 'zhsw:putian_water_supply_line',
        exceptions: 'application/vnd.ogc.se_inimage',
        srs: 'EPSG:4326',
        width: parseInt(map._container.clientWidth),
        height: parseInt(map._container.clientHeight),
        bbox: extent.join(','),
        ...(params || {})
    }
    const url = getResource(options.url || '/geoserver/wms', {
        token,
        params: {
           ..._params
        }
    });

    let {request, format, exceptions, width, height, ...infoParameters} = _params;
    return {
        url,
        rectangle,
        getFeatureInfoParameters: {
            ...infoParameters,
            width: 256,
            height: 256,
            request: 'GetFeatureInfo',
            info_format: 'application/json'
        }
    };
}

const getLayer = (options) => {
    return new ImageryLayer(new SingleTileImageryProvider(getUrlAndRectangle(options)));
}

class ImageLayer {
    constructor(options) {
        const {map, token, zIndex, params} = options;

        this.map = map;

        this.token = token;

        this.params = params;

        this.layer = getLayer(options);

        this.getFeatureInfo

        this.zIndex = map.getImageryLastIndex(zIndex);
        map.addLayer(this.layer, this.zIndex);

        // 添加相机监听事件
        map.camera.moveEnd.addEventListener(() => {
            this.replaceLayer();
            // this.updateLayer();
        })


        // const {url, rectangle } = getUrlAndRectangle(options)
        // this.entity = map.entities.add({
        //     name: "Rotating rectangle with rotating texture coordinate",
        //     rectangle: {
        //         coordinates: rectangle,
        //         material: url,
        //         classificationType: ClassificationType.TERRAIN,
        //     },
        // });
    }

    updateLayer() {
        const {url, rectangle } = getUrlAndRectangle({map: this.map, token: this.token, params: this.params});
        this.entity.rectangle.material._image.setValue(url);
        this.entity.rectangle.coordinates.setValue(rectangle);
    }

    replaceLayer() {
        let layer = getLayer({map: this.map, token: this.token, params: this.params});
        this.map.addLayer(layer, this.zIndex);
        layer.imageryProvider.readyPromise.then(() => {
            this.map.removeLayer(this.layer);
            this.layer = layer;
        })
    }
}

export default ImageLayer;
